import {
  CANDIDATE_DELETE,
  CANDIDATE_DELETE_FAILED,
  CANDIDATE_DELETE_SUCCESSFUL,
  CANDIDATE_LIST,
  CANDIDATE_LIST_FAILED,
  CANDIDATE_LIST_SUCCESSFUL,
  CANDIDATE_SEARCH,
  CANDIDATE_SEARCHLIST,
  CANDIDATE_SEARCHLIST_ERROR,
  CANDIDATE_SEARCHLIST_SUCCESS,
  CANDIDATE_SEARCH_FAILED,
  CANDIDATE_SEARCH_SUCCESSFUL,
  GET_MAPPED_CANDIDATE_DATA,
  GET_SEARCH_DATA,
  GET_SEARCH_FILTER_CANDIDATE_DATA,
  GET_SEARCH_MAPPED_CANDIDATE_DATA,
  GET_SEARCH_SUGGESTION_DATA_ERROR,
  GET_SEARCH_SUGGESTION_DATA_SUCCESS,
  GET_SEARCH_TABLE_SUGGESTION_DATA,
  GET_TABLE_SEARCH_FILTER
} from "./actionTypes"

const initialState = {
  candidateListError: null,
  message: null,
  loading: false,
  user: null,
  searchList:null,
  candidateDeleteSuccess:null,
  candidateDeleteError:null,
  suggestions : null
}

const getCandidateList = (state = initialState, action) => {
  switch (action.type) {
    case CANDIDATE_LIST :
      state = {
        ...state,
        candidateDeleteSuccess: null,
        loading: true,
        candidateListError: null,
      }
      break
    case CANDIDATE_LIST_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        user: action.payload,
        candidateListError: null,
      }
      break
    case CANDIDATE_LIST_FAILED:
     
      state = {
        ...state,
        user: null,
        loading: false,
        candidateListError: action.payload,
      }
      break
      case CANDIDATE_SEARCH:
        state = {
          ...state,
          loading: true,
          candidateSearchListError: null,
        }
        break
      case CANDIDATE_SEARCH_SUCCESSFUL:
        state = {
          ...state,
          loading: false,
          searchList: action.payload,
          candidateSearchListError: null,
        }
        break
      case CANDIDATE_SEARCH_FAILED:
       
        state = {
          ...state,
          searchList: null,
          loading: false,
          candidateSearchListError: action.payload,
        }
        break
        case CANDIDATE_DELETE:
          state = {
            ...state,
            loading: true,
            candidateDeleteError: null,
          }
          break
        case CANDIDATE_DELETE_SUCCESSFUL:
          state = {
            ...state,
            loading: false,
            candidateDeleteSuccess: action.payload,
            candidateDeleteError: null,
          }
          break
        case  CANDIDATE_DELETE_FAILED:
         
          state = {
            ...state,
            candidateDeleteSuccess: null,
            loading: false,
            candidateDeleteError: action.payload,
          }
          break
          
   // Candidate search listing 
   case CANDIDATE_SEARCHLIST:
    state = {
      ...state,
      loading: true,
      candidateListData: null,
    }
    break
  case CANDIDATE_SEARCHLIST_SUCCESS:
    state = {
      ...state,
      loading: false,
      user: action.payload,
      candidateListDataError: null,
    }
    break
  case CANDIDATE_SEARCHLIST_ERROR:
   
    state = {
      ...state,
      loading: false,
      candidateListData: null,
      candidateListDataError: action.payload,
    }
    break
    
  case GET_SEARCH_DATA:
   
    state = {
      ...state,
      loading: true,
      candidateListData: null,
      candidateListDataError: action.payload,
    }
    break
      
  case GET_MAPPED_CANDIDATE_DATA:
   
    state = {
      ...state,
        candidateDeleteSuccess: null,
        loading: true,
        candidateListError: null,
    }
    break
        
  case GET_SEARCH_MAPPED_CANDIDATE_DATA:
   
    state = {
      ...state,
        candidateDeleteSuccess: null,
        loading: true,
        candidateListError: null,
    }
    break
    case GET_SEARCH_MAPPED_CANDIDATE_DATA:
      state = {
        ...state,
        loading: true,
        user: null,
        candidateListDataError: null,
      }
      break
   case GET_SEARCH_FILTER_CANDIDATE_DATA:
    state = {
      ...state,
      loading: true,
      candidateListData: null,
    }
    break

    case GET_TABLE_SEARCH_FILTER:
      state = {
        ...state,
        loading: true,
        candidateListData: "",
      }
      break

    case GET_SEARCH_TABLE_SUGGESTION_DATA:
      state = {
        ...state,
        suggestions: null,
        // loading: true,
      }
      break

    case GET_SEARCH_SUGGESTION_DATA_SUCCESS:
      state = {
        ...state,
        loading: false,
        suggestions: action.payload,
      }
      break
    case GET_SEARCH_SUGGESTION_DATA_ERROR:
     
      state = {
        ...state,
        suggestions: null,
        loading: false
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default getCandidateList
